import * as React from 'react';

export type NavigationStackEntry = {
  value: string;
  label: string;
  isLoading?: boolean;
} | null;

export interface NavigationStackContextProps {
  navigationStack: NavigationStackEntry[];
  setNavigationStack: (navigationStack: NavigationStackEntry[]) => void;
}

const defaultValue: NavigationStackContextProps = {
  navigationStack: [],
  setNavigationStack: () => [],
};

const context = React.createContext(defaultValue);
export default context;
